import "./VesselPartsEditorComponent.scss";

import {
  BayLcgVcgTcgAndPairings,
  calculatePartsForVesselOne,
  preCalculateCurrentVesselParts,
} from "@tedivo/tedivo-bay-grid-pure";
import { IActionVesselPart, partsReducer } from "./partsReducer";
import {
  IBayLevelData,
  IBayLevelOffsetBottomBase,
  IVesselParts,
} from "open-vessel-definition";

import { drawSlotsNodes } from "./draw/drawSlotsNodes";
import { getTranslation } from "../../../../../../../app/i18/i18tn";
import { removeChildren } from "@tedivo/tedivo-dom-helpers";

export class TvdVesselPartsEditorComponent extends HTMLElement {
  private mainHolder: HTMLElement;

  private vesselPartsData: Array<IVesselParts> = [];
  private offsetBottomBases: Array<IBayLevelOffsetBottomBase> = [];
  private bls: IBayLevelData[] = [];
  private lcgVcgTcgAndPairings?: BayLcgVcgTcgAndPairings;

  public onApplyChanges: (() => void) | undefined = undefined;

  constructor() {
    super();
    this.mainHolder = document.createElement("div");
  }

  connectedCallback() {
    const mainHolder = this.mainHolder;
    mainHolder.className = "bay-slots-editor";

    const h2 = document.createElement("h2");
    h2.innerHTML = getTranslation("view:view3D.editor");
    h2.className = "subtitle";

    this.appendChild(h2);
    this.appendChild(mainHolder);

    this.update();

    forceScrollSideWays(mainHolder);
  }

  setData({
    vesselPartsData,
    offsetBottomBases,
    bls,
    lcgVcgTcgAndPairings,
  }: {
    vesselPartsData: Array<IVesselParts>;
    offsetBottomBases?: Array<IBayLevelOffsetBottomBase>;
    bls?: IBayLevelData[];
    lcgVcgTcgAndPairings?: BayLcgVcgTcgAndPairings;
  }) {
    this.vesselPartsData = vesselPartsData;
    if (bls) this.bls = bls;
    if (lcgVcgTcgAndPairings) this.lcgVcgTcgAndPairings = lcgVcgTcgAndPairings;
    if (offsetBottomBases) this.offsetBottomBases = offsetBottomBases;
  }

  update() {
    if (!this.lcgVcgTcgAndPairings) return;

    removeChildren(this.mainHolder);

    const preCalculatedSlots = preCalculateCurrentVesselParts(
      this.bls,
      this.vesselPartsData,
    );

    const vOneBaySlots = calculatePartsForVesselOne(
      preCalculatedSlots,
      this.lcgVcgTcgAndPairings,
      this.bls,
    );

    this.mainHolder.appendChild(
      drawSlotsNodes({
        calculatedSlots: vOneBaySlots,
        lcgVcgTcgAndPairings: this.lcgVcgTcgAndPairings,
        applyChanges: this.applyChanges,
      }),
    );

    if (this.onApplyChanges) {
      this.onApplyChanges();
    }
  }

  applyChanges = (cmd: IActionVesselPart) => {
    const newDataPartsSlots = partsReducer(this.vesselPartsData, cmd);

    this.setData({ vesselPartsData: newDataPartsSlots });
    this.update();
  };

  getVesselParts(): Array<IVesselParts> {
    return this.vesselPartsData;
  }

  getAdjustedBottomBases(): Array<IBayLevelOffsetBottomBase> {
    return this.offsetBottomBases || [];
  }
}

customElements.define(
  "tvd-vesselparts-editor-component",
  TvdVesselPartsEditorComponent,
);

declare global {
  interface HTMLElementTagNameMap {
    "tvd-vesselparts-editor-component": TvdVesselPartsEditorComponent;
  }
}

function forceScrollSideWays(element: HTMLElement) {
  const CONSTANT_SCROLL = 60;
  element.addEventListener("wheel", (event) => {
    const [x, y] = [event.deltaX, event.deltaY];
    let magnitude = 0;

    if (x === 0) {
      event.preventDefault();
      magnitude = y > 0 ? CONSTANT_SCROLL : -CONSTANT_SCROLL;
      element.scrollBy({ left: magnitude });
    }
  });
}
